import React from "react";
import Icon from "../assets/Icon";

function Footer({ emailColor }) {
  return (
    <div className="flex flex-col-reverse sm:flex-row gap-y-3 justify-between w-full items-end">
      <p className="text-[.8rem]">
        © {new Date().getFullYear()}, HirePlusPlus Technologies Private Limited, India
      </p>
      <div>
        <div className="flex justify-end items-center gap-[.45rem] text-[.8rem]">
          Powered by <Icon type="hire-logo" width="70" height="40" />{" "}
        </div>
        <div className="flex items-center gap-[.5rem] text-[.8rem] ">
          <Icon
            color={emailColor ? emailColor : "white"}
            type="email-logo"
            width="18"
            height="18"
          />{" "}
          <p className="">support@hireplusplus.com</p>
        </div>
      </div>
    </div>
  );
}

export default Footer;
